import { makeStyles } from 'tss-react/mui';

export default makeStyles<void, 'text' | 'icon'>()((theme, _params, classes) => ({
    menuItem: {
        color: theme.palette.default.main,
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        fontSize: 14,
        lineHeight: '21px',
        borderRadius: 16,
        '&:hover': {
            color: theme.palette.primary.main,
            background: theme.customPalette.common.lightGray,
            [`& .${classes.text}`]: {
                color: theme.palette.default.main
            }
        }
    },
    active: {
        background: theme.customPalette.common.lightGray,
        [`& .${classes.text}`]: {
            color: theme.palette.default.main
        },
        [`& .${classes.icon}`]: {
            color: theme.palette.primary.main
        }
    },
    text: {
        color: theme.customPalette.common.blueGray
    },
    textAdaptive: {
        transition: 'all 0.2s linear',
        '@media (max-width: 1024px)': {
            width: 0,
            display: 'none'
        },
        '@media (max-width: 460px)': {
            width: 'initial',
            display: 'block',
            fontSize: 16
        }
    },
    icon: {
        margin: 12
    },
    expanded: {
        [`& .${classes.icon}`]: {
            color: theme.palette.primary.main
        }
    },
    link: {
        textDecoration: 'none'
    }
}));
